// 工具校验类

// 校验耳标编号
export const validateTagSn = (rule, value, callback) => {
  if (value.length !== 0 && value.length !== 14) {
    callback(new Error('耳标编号必须是14位字符'));
  } else {
    callback();
  }
};
